export * from './acceso.service';
import { AccesoService } from './acceso.service';
export * from './avatar.service';
import { AvatarService } from './avatar.service';
export * from './cliente.service';
import { ClienteService } from './cliente.service';
export * from './consolidado.service';
import { ConsolidadoService } from './consolidado.service';
export * from './contacto.service';
import { ContactoService } from './contacto.service';
export * from './cuenta.service';
import { CuentaService } from './cuenta.service';
export * from './deposito.service';
import { DepositoService } from './deposito.service';
export * from './logs.service';
import { LogsService } from './logs.service';
export * from './menu.service';
import { MenuService } from './menu.service';
export * from './otp.service';
import { OtpService } from './otp.service';
export * from './pagoFacilito.service';
import { PagoFacilitoService } from './pagoFacilito.service';
export * from './pagoServicio.service';
import { PagoServicioService } from './pagoServicio.service';
export * from './parametrizacion.service';
import { ParametrizacionService } from './parametrizacion.service';
export * from './pregunta.service';
import { PreguntaService } from './pregunta.service';
export * from './prestamo.service';
import { PrestamoService } from './prestamo.service';
export * from './recuperacion.service';
import { RecuperacionService } from './recuperacion.service';
export * from './registro.service';
import { RegistroService } from './registro.service';
export * from './rol.service';
import { RolService } from './rol.service';
export * from './tipoIdentificacion.service';
import { TipoIdentificacionService } from './tipoIdentificacion.service';
export * from './transferencia.service';
import { TransferenciaService } from './transferencia.service';
export * from './usuario.service';
import { UsuarioService } from './usuario.service';
export const APIS = [AccesoService, AvatarService, ClienteService, ConsolidadoService, ContactoService, CuentaService, DepositoService, LogsService, MenuService, OtpService, PagoFacilitoService, PagoServicioService, ParametrizacionService, PreguntaService, PrestamoService, RecuperacionService, RegistroService, RolService, TipoIdentificacionService, TransferenciaService, UsuarioService];
